/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_Superset_Unlinked_ToastInputs */

const en_us2_plan_edit_superset_unlinked_toast = /** @type {(inputs: Plan_Edit_Superset_Unlinked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset undone`)
};

const pt_br2_plan_edit_superset_unlinked_toast = /** @type {(inputs: Plan_Edit_Superset_Unlinked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset desfeito`)
};

const es_419_plan_edit_superset_unlinked_toast = /** @type {(inputs: Plan_Edit_Superset_Unlinked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superserie deshecha`)
};

const pt_pt2_plan_edit_superset_unlinked_toast = /** @type {(inputs: Plan_Edit_Superset_Unlinked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset desfeito`)
};

const fr_fr2_plan_edit_superset_unlinked_toast = /** @type {(inputs: Plan_Edit_Superset_Unlinked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset annulé`)
};

const de_de2_plan_edit_superset_unlinked_toast = /** @type {(inputs: Plan_Edit_Superset_Unlinked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supersatz aufgelöst`)
};

const it_it2_plan_edit_superset_unlinked_toast = /** @type {(inputs: Plan_Edit_Superset_Unlinked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset annullato`)
};

/**
* | output |
* | --- |
* | "Superset undone" |
*
* @param {Plan_Edit_Superset_Unlinked_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_superset_unlinked_toast = /** @type {((inputs?: Plan_Edit_Superset_Unlinked_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Superset_Unlinked_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_superset_unlinked_toast(inputs)
	if (locale === "es-419") return es_419_plan_edit_superset_unlinked_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_superset_unlinked_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_superset_unlinked_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_superset_unlinked_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_superset_unlinked_toast(inputs)
	return en_us2_plan_edit_superset_unlinked_toast(inputs)
});
export { plan_edit_superset_unlinked_toast as "plan-edit.superset_unlinked_toast" }